export default {
  hero: {
    breadcrumbs: {
      home: 'Startseite',
      properties: 'Objekte'
    }
  },
  property: {
    title: 'Titel',
    description: 'Beschreibung',
    price: 'Preis',
    price_currency: 'Währung',
    gross_area: 'Gesamtfläche',
    net_area: 'Wohnfläche',
    floor: 'Etage',
    total_floors: 'Gesamtanzahl der Etagen',
    rooms: 'Anzahl der Zimmer',
    layout_type: 'Grundrisstyp',
    status: 'Objektstatus',
    purpose: 'Verwendungszweck',
    ownership: 'Eigentumsrecht',
    heating: 'Heizungsart',
    orientation: 'Ausrichtung',
    view: 'Aussicht',
    address: 'Adresse',
    year_of_construction: 'Baujahr',
    location: 'Standort',
    video: 'Videovorstellung',
    features: 'Merkmale',
    contact_agent: 'Makler kontaktieren',
    request_price: 'Aktuellen Preis anfragen',
    back_to_all: '← Zurück zu allen Objekten',
    developer: 'Bauträger',
    residential_complex: 'Wohnanlage',
    building: 'Gebäude',
    ai_prediction: 'KI-Bewertung',
    evaluation_chart: 'Bewertungsgrafik',
    map: 'Karte',
    gallery: 'Galerie',
    video_tour: 'Video-Tour',
    loading: 'Wohnungsdaten werden geladen...',
    catalog_id: 'Katalognummer',
    layout_type_label: 'Objekttyp',
    status_label: 'Status',
    purpose_label: 'Verwendungszweck',
    heating_label: 'Heizung',
    orientation_label: 'Ausrichtung',
    building_type_label: 'Gebäudetyp',
    view_label: 'Aussicht',
    citizenship_available: 'Geeignet für Staatsbürgerschaft',
    mortgage_available: 'Hypothek verfügbar',
    not_specified: 'Nicht angegeben',

    // Aus PropertyCharacteristics
    country: 'Land',
    region: 'Region',
    city: 'Stadt',
    district: 'Stadtteil',
    residential_complex_label: 'Wohnanlage',
    building_label: 'Gebäude',
    rooms_label: 'Anzahl der Zimmer',
    floor_label: 'Etage',
    total_floors_label: 'Etagen im Gebäude',
    gross_area_label: 'Gesamtfläche',
    net_area_label: 'Wohnfläche',
    year_of_construction_label: 'Baujahr',
    heating_label_fallback: 'Heizung',
    orientation_label_fallback: 'Ausrichtung',
    building_type_label_fallback: 'Gebäudetyp',
    view_label_fallback: 'Aussicht',

    gallery_title: 'Objektfotos',

    agent: {
      full_name: 'Makler',
      agency: 'Agentur',
      phone: 'Telefon'
    },

    amenities: {
      title: 'Ausstattung',
      empty: 'Keine Ausstattung angegeben'
    },

    characteristics: {
      title: 'Eigenschaften',
      loading: 'Eigenschaften werden geladen...'
    },

    video: {
      no_video: 'Kein Video verfügbar'
    },

    unpublished: {
      title: '🏗️ Objekt nicht veröffentlicht',
      message: 'Die Wohnung ist nicht für die öffentliche Ansicht verfügbar.',
      location: 'Standort',
      home: 'Zur Startseite'
    }
  }
}
